const splitJoinedValues = (value?: string): string[] =>
  value
    ?.split(',')
    .map(item => item.trim())
    .filter(Boolean) ?? [];

export default splitJoinedValues;
